import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaSetNode extends ValuableNode {
  @fromSpecific()
  @reactive('deep')
  entries?: any[]
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Set': SchemaSetNode
  }
}
